let elasticSettingsPromise = null;

(function ($, Drupal, drupalSettings) {
  "use strict";

  elasticSettingsPromise = new Promise((resolve) => {
    Drupal.behaviors.elasticSearchUrl = {
      attach: function (context, settings) {
        if (context === document) {
          const elasticSettings = {
            elasticSearchUrl: drupalSettings.elasticSearchUrl,
          };
          resolve(elasticSettings);
        }
      },
    };
  });
})(jQuery, Drupal, drupalSettings);

export async function getElasticSearchUrl() {
  const elasticSettings = await elasticSettingsPromise;
  return elasticSettings.elasticSearchUrl;
}
